import { useCallback, useReducer } from "react";

export interface CheckedDeleteResourcesState {
  layers: boolean | null;
  tables: boolean | null;
}

export interface ToggleDeleteResources {
  layers: VoidFunction;
  tables: VoidFunction;
}

const initialState: CheckedDeleteResourcesState = {
  layers: null,
  tables: null,
};

const TOGGLE_DELETE_LAYERS = "toggleDeleteLayers";
const TOGGLE_DELETE_TABLES = "toggleDeleteTables";

export const useDeleteResourcesChoice = (): [CheckedDeleteResourcesState, ToggleDeleteResources] => {
  const [checkedState, dispatch] = useReducer(reducer, initialState);

  const layers = useCallback(() => dispatch({ type: TOGGLE_DELETE_LAYERS }), []);
  const tables = useCallback(() => dispatch({ type: TOGGLE_DELETE_TABLES }), []);

  return [checkedState, { layers, tables }];
};

function reducer(state, action): { tables: boolean; layers: boolean } {
  switch (action.type) {
    case TOGGLE_DELETE_LAYERS:
      return { ...state, layers: !state.layers };
    case TOGGLE_DELETE_TABLES:
      return { ...state, tables: !state.tables };
    default:
    // ignore
  }
}
